import './Loading.scss';

const Loading = () => {
    return (
        <div class="loading">
            <div class="root">
                <div class="pl">
                    <div class="pl__coin">
                        <div class="pl__coin-flare"></div>
                        <div class="pl__coin-flare"></div>
                        <div class="pl__coin-flare"></div>
                        <div class="pl__coin-flare"></div>
                        <div class="pl__coin-layers">
                            <div class="pl__coin-layer">
                                <div class="pl__coin-inscription"></div>
                            </div>
                            <div class="pl__coin-layer"></div>
                            <div class="pl__coin-layer"></div>
                            <div class="pl__coin-layer"></div>
                            <div class="pl__coin-layer">
                                <div class="pl__coin-inscription"></div>
                            </div>
                        </div>
                    </div>
                    <div class="pl__shadow"></div>
                </div>
            </div>
        </div>
    );
};

export default Loading;
